<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">数据管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>交易统计</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-date-picker size="mini" v-model="value2" type="daterange" align="right" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" format="yyyy-MM-dd" clearable
          value-format="yyyy-MM-dd">
        </el-date-picker>
        <el-tooltip placement="top">
          <div slot="content">
            查询起始时间为‘开始日期’UTC-0 00:00:00，<br />结束时间为‘结束日期’
            UTC-0 23:59:59<br />如果时间选项为空，默认为当天0点至24点
          </div>
          <el-button type="info" size="mini" circle>
            <i class="el-icon-warning-outline"></i>
          </el-button>
        </el-tooltip>
        <el-select v-model="topChannelUserId" placeholder="请选择顶级合伙人" clearable filterable size="mini">
          <el-option v-for="item in topChannelList" :key="item.topChannelUserId" :label="item.remark
            ? `${item.topChannelUserId} (${item.remark})`
            : `${item.topChannelUserId}`
            " :value="item.topChannelUserId">
          </el-option>
        </el-select>
        <el-button size="mini" @click="handleSearch" type="primary">搜索</el-button>
      </div>
      <div class="pl_total_box total_box">
        <div class="pl_total total">
          <span>注册人数汇总</span>
          <span></span>
          <span>{{ tradeStatisticTotal.registerCount }}</span>
        </div>
        <div class="pl_total total">
          <span>首冲人数汇总</span>
          <span></span>
          <span>{{ tradeStatisticTotal.firstDepositNum }}</span>
        </div>
        <div class="pl_total total">
          <span>开仓人数汇总</span>
          <span></span>
          <span>{{ tradeStatisticTotal.tradeUserCount }}</span>
        </div>
        <div class="pl_total total">
          <span>平仓人数汇总</span>
          <span></span>
          <span>{{ tradeStatisticTotal.positionUidCount }}</span>
        </div>
        <div class="pl_total total">
          <span>平仓数量汇总</span>
          <span></span>
          <span>{{ tradeStatisticTotal.positionCount }}</span>
        </div>
        <div class="pl_total total">
          <span>充值汇总</span>
          <span></span>
          <span>{{ tradeStatisticTotal.depositAmount }}</span>
        </div>
        <div class="pl_total total">
          <span>提现汇总</span>
          <span></span>
          <span>{{ tradeStatisticTotal.withdrawAmount }}</span>
        </div>

        <div class="pl_total total">
          <span>提现手续费汇总</span>
          <span></span>
          <span>{{ tradeStatisticTotal.withdrawFee }}</span>
        </div>
        <div class="pl_total total">
          <span>净入金汇总</span>
          <span></span>
          <span>{{ tradeStatisticTotal.totalDeposit }}</span>
        </div>
        <div class="pl_total total">
          <span>用户余额汇总</span>
          <span></span>
          <span>{{ tradeStatisticTotal.userBalance }}</span>
        </div>
        <div class="pl_total total">
          <span>总手续费汇总</span>
          <span></span>
          <span>{{ tradeStatisticTotal.totalFee }}</span>
        </div>
        <div class="pl_total total">
          <span>体验金抵扣手续费汇总(USDT)</span>
          <span></span>
          <span>{{ tradeStatisticTotal.experienceDeductFee }}</span>
        </div>
        <div class="pl_total total">
          <span>平仓盈亏汇总</span>
          <span></span>
          <span>{{ tradeStatisticTotal.positionProfit }}</span>
        </div>
        <div class="pl_total total">
          <span>体验金抵扣盈亏汇总(USDT)</span>
          <span></span>
          <span>{{ tradeStatisticTotal.experiencePnlDeduct }}</span>
        </div>
        <div class="pl_total total"><span>手续费抵扣券抵扣金额汇总(USDT)</span><span></span><span>{{
          tradeStatisticTotal.feeCouponDeduct }}</span></div>
        <div class="pl_total total"><span>盈亏抵扣券抵扣金额汇总(USDT)</span><span></span><span>{{
          tradeStatisticTotal.pnlCouponDeduct }}</span></div>
        <div class="pl_total total">
          <span>体验金抵扣资金费汇总(USDT)</span>
          <span></span>
          <span>{{ tradeStatisticTotal.experienceFundingFeeDeduct }}</span>
        </div>
        <div class="pl_total total">
          <span>手续费已返汇总</span>
          <span></span>
          <span>{{ tradeStatisticTotal.feeDay }}</span>
        </div>
        <div class="pl_total total">
          <span>赠币汇总</span>
          <span></span>
          <span>{{ tradeStatisticTotal.profitWeek }}</span>
        </div>
        <div class="pl_total total">
          <span>净利润汇总</span>
          <span></span>
          <span>{{ tradeStatisticTotal.netProfit }}</span>
        </div>
        <div class="pl_total total">
          <span>内部转入汇总</span>
          <span></span>
          <span>{{ tradeStatisticTotal.internalTransferInAmount }}</span>
        </div>
        <div class="pl_total total">
          <span>内部转出汇总</span>
          <span></span>
          <span>{{ tradeStatisticTotal.internalTransferOutAmount }}</span>
        </div>
        <!-- <div class="pl_total total">
          <span>高频手续费汇总</span>
          <span></span>
          <span>{{ tradeStatisticTotal.highCountFee }}</span>
        </div>
        <div class="pl_total total">
          <span>超短线手续费汇总</span>
          <span></span>
          <span>{{ tradeStatisticTotal.shortLineFee }}</span>
        </div> -->
      </div>
      <br />
      <!-- <CloumnLine @refreshEcherts="refreshEcherts" /> -->
      <MyTable :tabData="tabData" :totalCount="totalCount" :topChannelUserId="topChannelUserId" @refreshTab="refreshTab"
        ref="MyTable" />
    </el-card>
  </div>
</template>

<script>
import CloumnLine from './components/cloumnLine'
import MyTable from './components/table'
import { mapActions, mapMutations, mapState } from 'vuex'
import './store'
import api from './api'
export default {
  name: 'Report',
  components: {
    CloumnLine,
    MyTable,
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      value2: '',
      tabData: [],
      totalCount: 0,
      topChannelList: [],
      topChannelUserId: '',
      cacheTabName: 'oneTable',
    }
  },
  computed: {
    ...mapState('transactionStatistics', ['tradeStatisticTotal']),
  },
  watch: {
    // value2: {
    //   handler(val, oldVal) {
    //     this.changeTime(val);
    //   },
    //   deep: true,
    // },
  },
  methods: {
    ...mapMutations('transactionStatistics', [
      'setParamsTime',
      'setOneEchertsData',
      'setTwoEchertsData',
      'setThreeEchertsData',
    ]),
    ...mapActions('transactionStatistics', ['fetchTradeStatisticTotal']),
    // changeTime(val) {
    //   this.setParamsTime({
    //     startTime: val && val[0] ? val[0] : "",
    //     endTime: val && val[1] ? val[1] : "",
    //   });
    // },
    refreshTab(val) {
      const { page, size } = val
      this.getData(page, size)
      this.getTradeStatisticTotal(page, size)
    },
    handleSearch() {
      this.$refs.MyTable.handlePageChanged(
        {
          page: 1,
          size: 10,
        },
        true
      )
      this.getData()
      // this.getOneEcherts();
      // this.getTwoEcherts();
      // this.getThreeEcherts();
      this.getTradeStatisticTotal()
    },
    getData(page = 1, size = 10) {
      api
        .getTradeStatistic({
          startTime: this.value2 && this.value2[0] ? this.value2[0] : '',
          endTime: this.value2 && this.value2[1] ? this.value2[1] : '',
          size,
          page,
          topChannelUserId: this.topChannelUserId,
        })
        .then((res) => {
          if (res.code == 0) {
            const { records, total } = res.data
            this.tabData = records
            this.totalCount = total
          }
        })
    },
    getOneEcherts() {
      // 金额
      const startTime = this.value2 && this.value2[0] ? this.value2[0] : ''
      const endTime = this.value2 && this.value2[1] ? this.value2[1] : ''
      const topChannelUserId = this.topChannelUserId
      const oneTabRequest = [
        api.tradeCharts({
          startTime,
          endTime,
          type: 'totalFee', // 总手续费
          topChannelUserId,
        }),
        api.tradeCharts({
          startTime,
          endTime,
          type: 'depositAmount', // 充值
          topChannelUserId,
        }),

        api.tradeCharts({
          startTime,
          endTime,
          type: 'withdrawAmount', // 提现
          topChannelUserId,
        }),
        api.tradeCharts({
          startTime,
          endTime,
          type: 'withdrawFee', // 提现手续费
          topChannelUserId,
        }),

        api.tradeCharts({
          startTime,
          endTime,
          type: 'totalDeposit', // 净入金
          topChannelUserId,
        }),

        api.tradeCharts({
          startTime,
          endTime,
          type: 'userBalance', // 用户余额
          topChannelUserId,
        }),
        api.tradeCharts({
          startTime,
          endTime,
          type: 'netProfit', // 净利润
          topChannelUserId,
        }),
        api.tradeCharts({
          startTime,
          endTime,
          type: 'positionProfit', // 平仓盈亏
          topChannelUserId,
        }),
      ]
      Promise.allSettled(oneTabRequest).then((results) => {
        const res = results
          .filter((i) => i.status === 'fulfilled')
          .map((i) => i.value.data)
        this.setOneEchertsData(res)
      })
    },
    getTwoEcherts() {
      // 金额
      const startTime = this.value2 && this.value2[0] ? this.value2[0] : ''
      const endTime = this.value2 && this.value2[1] ? this.value2[1] : ''
      const topChannelUserId = this.topChannelUserId
      const twoTabRequest = [
        api.tradeCharts({
          startTime,
          endTime,
          type: 'registerCount', // 注册用户数
          topChannelUserId,
        }),
        api.tradeCharts({
          startTime,
          endTime,
          type: 'firstDepositNum', // 首冲人数
          topChannelUserId,
        }),
        api.tradeCharts({
          startTime,
          endTime,
          type: 'tradeUserCount', // 开仓人数
          topChannelUserId,
        }),
        api.tradeCharts({
          startTime,
          endTime,
          type: 'positionUidCount', // 平仓人数
          topChannelUserId,
        }),
      ]
      Promise.allSettled(twoTabRequest).then((results) => {
        const res = results
          .filter((i) => i.status === 'fulfilled')
          .map((i) => i.value.data)
        this.setTwoEchertsData(res)
      })
    },
    getThreeEcherts() {
      // 金额
      const startTime = this.value2 && this.value2[0] ? this.value2[0] : ''
      const endTime = this.value2 && this.value2[1] ? this.value2[1] : ''
      const topChannelUserId = this.topChannelUserId
      const threeTabRequest = [
        api.tradeCharts({
          startTime,
          endTime,
          type: 'positionCount', // 平仓数量
          topChannelUserId,
        }),
        api.tradeCharts({
          startTime,
          endTime,
          type: 'feeDay', // 手续费日返
          topChannelUserId,
        }),
        api.tradeCharts({
          startTime,
          endTime,
          type: 'profitWeek', // 盈亏周返
          topChannelUserId,
        }),
      ]
      Promise.allSettled(threeTabRequest).then((results) => {
        const res = results
          .filter((i) => i.status === 'fulfilled')
          .map((i) => i.value.data)
        this.setThreeEchertsData(res)
      })
    },
    refreshEcherts(name) { },
    getTopChannelData() {
      api.topChannelList().then((res) => {
        res.code == 0 && (this.topChannelList = res.data)
      })
    },

    getTradeStatisticTotal(page = 1, size = 10) {
      this.fetchTradeStatisticTotal({
        startTime: this.value2 && this.value2[0] ? this.value2[0] : '',
        endTime: this.value2 && this.value2[1] ? this.value2[1] : '',
        size,
        page,
        topChannelUserId: this.topChannelUserId,
      })
    },
  },
  mounted() {
    this.getTradeStatisticTotal()
    this.getTopChannelData()
    this.getData()
    // this.getOneEcherts();
    // this.getTwoEcherts();
    // this.getThreeEcherts();
  },
}
</script>

<style lang="less" scoped>
.actions-bar {
  display: flex;
  align-items: center;
}

.el-input {
  width: 300px;
}

.el-date-editor,
.el-input {
  margin-right: 10px;
}

.userContent {
  margin-top: 10px;
  width: 100%;
  // border: 1px solid tomato;
  height: 500px;
  padding: 10px;
  box-sizing: border-box;

  .rank {
    font-size: 20px;
    display: block;
    margin-bottom: 10px;
  }
}

.columnData {
  box-sizing: border-box;
  width: 100%;
  // height: 300px;
  // border: 1px solid gray;
  padding: 10px;
}

.total_box {
  flex-wrap: wrap;

  .total {
    margin-bottom: 12px;
  }
}
</style>
